var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',[_c('Dictionary',{staticClass:"dictionary",attrs:{"module":"facebookBrowserDetected","string":"subtitle","replace":{subdomain: _vm.subdomain}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }